import React, { memo, useCallback } from "react";
import { DatoKeyValuesMap } from "../data/datoContentData";
import { ColorProvider } from "../context/colorContext";
import Component from "./component";
import { Wrapper, Container } from "../styles/components/section";
import Heading from "./heading";

const Section = memo(({ datoContentData }) => {
  const findComponentByKey = useCallback(key => {
    const section = DatoKeyValuesMap.find(section => section.key === key);
    if (!section) {
      console.error(`Component with key "${key}" not found.`);
      return null;
    }
    return section.component;
  }, []);

  return (
    <ColorProvider>
      <Heading />
      <Wrapper>
        {datoContentData?.map(contentItem => {
          const SectionComponent = contentItem.key
            ? findComponentByKey(contentItem.key)
            : contentItem;

          if (!SectionComponent) return null;

          return (
            <Container
              key={contentItem.id}
              className={contentItem.key || contentItem.id}
            >
              {contentItem.key ? (
                <SectionComponent
                  title={contentItem.key}
                  {...contentItem.content}
                />
              ) : (
                <Component {...contentItem} />
              )}
            </Container>
          );
        })}
      </Wrapper>
    </ColorProvider>
  );
});

export default Section;
